var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColinKlein4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_16_1214)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "url(#paint0_linear_16_1214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.334 12.1895C11.8613 12.1895 11.4355 12.2715 11.0566 12.4355C10.6816 12.5957 10.3613 12.8301 10.0957 13.1387C9.83398 13.4434 9.63281 13.8125 9.49219 14.2461C9.35156 14.6797 9.28125 15.168 9.28125 15.7109C9.28125 16.4297 9.39258 17.0547 9.61523 17.5859C9.8418 18.1133 10.1777 18.5215 10.623 18.8105C11.0723 19.0996 11.6328 19.2441 12.3047 19.2441C12.6875 19.2441 13.0469 19.2129 13.3828 19.1504C13.7227 19.084 14.0527 19.002 14.373 18.9043V19.7715C14.0605 19.8887 13.7324 19.9746 13.3887 20.0293C13.0449 20.0879 12.6367 20.1172 12.1641 20.1172C11.293 20.1172 10.5645 19.9375 9.97852 19.5781C9.39648 19.2148 8.95898 18.7031 8.66602 18.043C8.37695 17.3828 8.23242 16.6035 8.23242 15.7051C8.23242 15.0566 8.32227 14.4648 8.50195 13.9297C8.68555 13.3906 8.95117 12.9258 9.29883 12.5352C9.65039 12.1445 10.0801 11.8438 10.5879 11.6328C11.0996 11.418 11.6855 11.3105 12.3457 11.3105C12.7793 11.3105 13.1973 11.3535 13.5996 11.4395C14.002 11.5254 14.3652 11.6484 14.6895 11.8086L14.291 12.6523C14.0176 12.5273 13.7168 12.4199 13.3887 12.3301C13.0645 12.2363 12.7129 12.1895 12.334 12.1895ZM22.4062 20H21.2285L18.1406 15.834L17.2266 16.6543V20H16.2305V11.4336H17.2266V15.7051C17.4492 15.4512 17.6777 15.1992 17.9121 14.9492C18.1465 14.6953 18.3789 14.4395 18.6094 14.1816L21.1113 11.4336H22.2773L18.8672 15.1484L22.4062 20Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_16_1214",
    x: -40,
    y: -40,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_1214"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_1214",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_1214",
    x1: 23.9103,
    y1: 0.00000248606,
    x2: -0.37812,
    y2: 13.4984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E885F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA61D3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColinKlein4);
export default __webpack_public_path__ + "static/media/Colin-Klein-4.69139c7677a08cd9b62853cb585adcae.svg";
export { ForwardRef as ReactComponent };